import { useMemo } from "react";

import { useSearchWheelsByVehicle } from "../../../../queries/useSearchWheelsByVehicle";
import { matchPartPricing } from "../../../../util/matchPartPricing";
import { useWheelPrice } from "./useWheelPrice";

export const dealerWheelPriceFilters: [number, number][] = [
  [0, 100],
  [100, 200],
  [200, 300],
  [300, 400],
  [400, 500],
  [500, 600],
  [600, Infinity],
];

export const useWheelPriceOptions = (): Option[] => {
  const { data: wheels } = useSearchWheelsByVehicle({
    keepPreviousData: true,
  });
  const [pricing] = useWheelPrice();
  const options = useMemo(
    () =>
      dealerWheelPriceFilters
        .map<Option>((range, value) => {
          const checked = pricing.includes(value);
          const count =
            wheels?.allParts.filter(({ partPricing }) =>
              matchPartPricing(partPricing, range)
            ).length || 0;
          return {
            checked,
            count,
            range,
            value,
          };
        })
        .filter(({ count }) => count > 0),
    [wheels?.allParts, pricing]
  );
  return options;
};

type Option = {
  checked: boolean;
  count: number;
  range: [number, number];
  value: number;
};
